const defaultSearchScope = (user) => {
  return user.default_search_scope_type === 'my_institution_only' ? 'institution' : 'all';
};

export { defaultSearchScope };
